import React from "react";

import { Network } from "../../services/NetworkApi";
import { ReadOnlyWrapper } from "../ReadOnlyWrapper";
import { useSnackbar } from "../../hooks/useSnackbar";

import Api from "../../services/Api";
import useAuth from "../../routes/login/AuthContext";
import { useNetworkContext } from "../../contexts/NetworkContext/context";
import { WrapperWithTitle } from "../WrapperWithTitle";
import { Grid } from "../../UI/Grid";
import { Radio } from "../../UI/Radio";

interface IProps {
  l2?: Network | null;
  isDisabled?: boolean;
}

export const ProfilePersonalPronouns: React.FC<IProps> = (props) => {
  const { showErrorSnackbar, showSuccessSnackbar } = useSnackbar();
  const { l2Id, l1Id } = props?.l2 || {};
  const { getAuthToken, isSuperAdminRead } = useAuth();
  const { loadNetworkInfoForNetworks } = useNetworkContext();
  const [isLoading, setIsLoading] = React.useState(false);
  const [personalProNounsEnabled, setPersonalProNounsEnabled] = React.useState(
    String(!!props.l2?.personalProNounEnabled)
  );

  const handleChange = async ({
    currentTarget: { value },
  }: React.SyntheticEvent<any>) => {
    setIsLoading(true);

    try {
      await Api.setPersonalPronouns(
        l1Id,
        l2Id,
        {
          personalProNounsEnabled: JSON.parse(value),
        },
        await getAuthToken()
      );

      setPersonalProNounsEnabled(value);

      l1Id && await loadNetworkInfoForNetworks([l1Id]);

      showSuccessSnackbar("Saved Changes");
    } catch (error) {
      showErrorSnackbar("An Error Occurred");
    }

    setIsLoading(false);
  };

  React.useEffect(() => {
    setPersonalProNounsEnabled(String(!!props.l2?.personalProNounEnabled));
  }, [props.l2?.personalProNounEnabled]);

  return (
    <WrapperWithTitle title="Do you want to allow users to add personal pronouns to their profile?">
      <ReadOnlyWrapper>
        <Grid container spacing={2}>
          <Grid item>
            <Radio
              isDisabled={isLoading || props.isDisabled || isSuperAdminRead()}
              isChecked={personalProNounsEnabled === String(true)}
              value={String(true)}
              label="Yes"
              onChange={handleChange}
            />
          </Grid>
          <Grid item>
            <Radio
              isDisabled={isLoading || props.isDisabled || isSuperAdminRead()}
              isChecked={personalProNounsEnabled === String(false)}
              value={String(false)}
              label="No"
              onChange={handleChange}
            />
          </Grid>
        </Grid>
      </ReadOnlyWrapper>
    </WrapperWithTitle>
  );
};
